import InvertObjectIcon from './component'

export default InvertObjectIcon
